<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Unread chat messages (Dashboard unread chat messages widget title) - Unread chat messages') }}</h4>
  </div>
  <div class="card-body">
    @for(unreadChatMessages of (fetchUnreadChatMessages | async); track unreadChatMessages){
      <div class="transaction-item" (click)="openDocument(unreadChatMessages)">
        <div class="media align-items-center">
          <div class="avatar bg-light-info rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-message-square"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title">{{ unreadChatMessages?.roleable?.name }}</h6>
          </div>
        </div>
        <div><small class="text-muted">{{ unreadChatMessages.unread }}</small></div>
      </div>
    } @empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No unread messages (general) - No unread messages') }}</p>
      </div>
    }
  </div>
</ng-container>